document.addEventListener(
  'click',
  (event) => {
    const target = event.composedPath()[0];
    const trigger = target?.closest?.('xo-product-quick-view-trigger[xo-product-url]');
    if (!trigger) return;

    const productUrl = trigger.getAttribute('xo-product-url');
    if (!productUrl) return;

    trigger.setAttribute('xo-product-url', new URL(productUrl, window.location.origin).href);
  },
  true
);
